export default {
  title: 'Detalles del código promocional',
  back: 'Volver a códigos promocionales',
  tabs: {
    customers: 'Clientes',
    orders: 'Pedidos',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Valor medio del pedido',
    customer_adoption: 'Clientes únicos',
  },
  toasts: {
    failed_to_load_stats: 'Error al cargar estadísticas',
  },
};
